'use client';

import { withClass } from "../with-class";
import A from "../A";
import styles from "./SubtleA.module.css";

export const SubtleA = withClass(A, styles.a);
